"use client";

import { ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Patientengagementcallout() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="2182" id="patientengagementcallout" className="relative bg-background text-foreground overflow-hidden py-24 md:py-32 lg:py-[140px] px-6 md:px-10 lg:px-16">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.03] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} />

      <div className="relative max-w-4xl mx-auto text-center">
        <div ref={contentRef} className="transition-all duration-[800ms] ease-out flex flex-col items-center" style={{
        opacity: contentVisible ? 1 : 0,
        transform: contentVisible ? "translateY(0)" : "translateY(24px)"
      }}>
          <h2 className="font-serif font-medium leading-tight mb-8 text-4xl md:text-5xl lg:text-6xl text-foreground">
            Questions Before Your Visit?
          </h2>

          <p className="font-default text-base md:text-lg leading-relaxed mb-12 text-muted-foreground max-w-2xl">
            Our team is here to help you prepare for your appointment. Whether you have questions about scheduling, need to confirm a referral, or want to ensure we have received your medical records and insurance information, please don't hesitate to reach out. Remember to bring your current medications and a valid ID to your visit.
          </p>

          <div className="flex flex-col sm:flex-row gap-6 items-center justify-center">
            <Button asChild size="lg" className="font-default text-base px-8 h-12 rounded-md shadow-md hover:shadow-lg transition-shadow bg-primary text-primary-foreground">
              <Link to="tel:+14126729240">Call (412) 672-9240</Link>
            </Button>

            <Link to="/ContactPage" className="inline-flex items-center gap-2 font-default text-base group text-primary">
              <span className="border-b pb-1 transition-colors border-primary">
                Contact Office
              </span>
              <ArrowUpRight className="size-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}